import { fitBounds } from "google-map-react";

// Leave room for the search controls, marker labels and map controls.
export const overviewPadding = { horizontal: 48, vertical: 128 };

export function initialOverview(
  places: ReadonlyArray<{ lat: unknown; lng: unknown }>,
  width: number,
  height: number
) {
  const coordinate = (value: unknown) =>
    typeof value === "number" || (typeof value === "string" && value.trim())
      ? Number(value) : NaN;
  const points = places.map(place => ({ lat: coordinate(place.lat), lng: coordinate(place.lng) }))
    .filter(point => Number.isFinite(point.lat) && Number.isFinite(point.lng) &&
      Math.abs(point.lat) <= 85 && Math.abs(point.lng) <= 180);
  const size = {
    width: width - overviewPadding.horizontal * 2,
    height: height - overviewPadding.vertical * 2,
  };
  if (!points.length || size.width <= 0 || size.height <= 0) return null;
  const north = Math.max(...points.map(point => point.lat));
  const south = Math.min(...points.map(point => point.lat));
  const east = Math.max(...points.map(point => point.lng));
  const west = Math.min(...points.map(point => point.lng));
  if (north === south && east === west) return { center: points[0], zoom: 12 };
  const view = fitBounds({ ne: { lat: north, lng: east }, sw: { lat: south, lng: west } }, size);
  return { center: view.center, zoom: Math.min(12, view.zoom) };
}
